import { orderByDate } from "./utils";
import CanvasJSReact from "@canvasjs/react-charts";

export function getECGLayout(_traceECG, frequency) {
  const traceECG = orderByDate(_traceECG);
  const color = "#F99";
  const totale_punti_riga = 8 * frequency;
  const scaleFactorX = 200 / totale_punti_riga;
  const scaleFactorY = 20;
  const offsetY = 0.5;
  const thickGrid = 2,
    normalGrid = 1.5,
    thinGrid = 0.6;

  let layout = {
    interactivityEnabled: false,
    theme: "light2",
    zoomEnabled: false,
    height: 250,
    // title: {
    //   text: "Grafico ECG",
    //   horizontalAlign: "left",
    //   fontColor: "black",
    // },
    axisY: {
      stripLines: [],
      gridColor: color,
      lineColor: color,
      gridThickness: thickGrid,
      tickThickness: 0,
      minimum: -20,
      maximum: 20,
      interval: 20,
      labelFormatter: function (e) {
        return "";
      },
    },
    axisX: {
      stripLines: [],
      gridColor: color,
      lineColor: color,
      // tickThickness: 0,
      gridThickness: thickGrid,
      tickLength: 5,
      maximum: 200,
      minimum: 0,
      interval: 25,
      labelFormatter: function (e) {
        const tick = e.chart.options.ecg_index * 8 + e.value / 25;
        return e.value === 0 ? "" : `${tick}s`;
      },
    },
    data: [
      {
        type: "line",
        color: "black",
        dataPoints: traceECG.map((el) => ({
          x: el.x * scaleFactorX,
          y: (el.y - offsetY) * scaleFactorY,
        })),
      },
    ],
  };

  // draw strip lines
  for (let i = layout.axisY.minimum; i < layout.axisY.maximum; i += 1) {
    layout.axisY.stripLines.push({
      value: i,
      thickness: Math.abs(i) % 5 != 0 ? thinGrid : normalGrid,
      color: color,
    });
  }

  for (let i = layout.axisX.minimum; i < layout.axisX.maximum; i += 1) {
    layout.axisX.stripLines.push({
      value: i,
      thickness: Math.abs(i) % 5 != 0 ? thinGrid : normalGrid,
      color: color,
    });
  }

  return layout;
}

export function normalizeAmplitude(traceECG) {
  const ecgSignal = traceECG.map((el) => el.y);
  const min = Math.min(...ecgSignal);
  const max = Math.max(...ecgSignal);
  const normalized = ecgSignal.map((sample) => (sample - min) / (max - min));
  traceECG.forEach((el, index) => (traceECG[index].y = normalized[index]));
  return traceECG;
}
